exports.ById = {
  1: {
    Id: 1,
    Name: 'major_classification.administrative_back_office_bpo',
    Localization: 'major_classification.administrative_back_office_bpo',
    ClassificationNumber: 100
  },
  2: {
    Id: 2,
    Name: 'major_classification.management_consulting_services',
    Localization: 'major_classification.management_consulting_services',
    ClassificationNumber: 200
  },
  3: {
    Id: 3,
    Name: 'major_classification.technology_services',
    Localization: 'major_classification.technology_services',
    ClassificationNumber: 300
  },
  4: {
    Id: 4,
    Name: 'major_classification.research_and_development',
    Localization: 'major_classification.research_and_development',
    ClassificationNumber: 400
  },
  5: {
    Id: 5,
    Name: 'major_classification.engineering',
    Localization: 'major_classification.engineering',
    ClassificationNumber: 500
  },
  6: {
    Id: 6,
    Name: 'major_classification.supply_chain_management_services',
    Localization: 'major_classification.supply_chain_management_services',
    ClassificationNumber: 600
  },
  7: {
    Id: 7,
    Name: 'major_classification.sales_advertising_marketing_services',
    Localization: 'major_classification.sales_advertising_marketing_services',
    ClassificationNumber: 700
  },
  8: {
    Id: 8,
    Name: 'major_classification.maintenance_repair_overhaul_services',
    Localization: 'major_classification.maintenance_repair_overhaul_services',
    ClassificationNumber: 800
  },
  9: {
    Id: 9,
    Name: 'major_classification.distributors',
    Localization: 'major_classification.distributors',
    ClassificationNumber: 900
  },
  10: {
    Id: 10,
    Name: 'major_classification.environmental_services',
    Localization: 'major_classification.environmental_services',
    ClassificationNumber: 1000
  },
  11: {
    Id: 11,
    Name: 'major_classification.rental_and_leasing',
    Localization: 'major_classification.rental_and_leasing',
    ClassificationNumber: 1100
  },
  13: {
    Id: 13,
    Name: 'major_classification.contract_manufacturer',
    Localization: 'major_classification.contract_manufacturer',
    ClassificationNumber: 1300
  },
  14: {
    Id: 14,
    Name: 'major_classification.energy_utility_services',
    Localization: 'major_classification.energy_utility_services',
    ClassificationNumber: 1400
  },
  15: {
    Id: 15,
    Name: 'major_classification.financial_services',
    Localization: 'major_classification.financial_services',
    ClassificationNumber: 1500
  },
  16: {
    Id: 16,
    Name: 'major_classification.insurance_services',
    Localization: 'major_classification.insurance_services',
    ClassificationNumber: 1600
  },
  17: {
    Id: 17,
    Name: 'major_classification.real_estate_services',
    Localization: 'major_classification.real_estate_services',
    ClassificationNumber: 1700
  },
  18: {
    Id: 18,
    Name: 'major_classification.retail',
    Localization: 'major_classification.retail',
    ClassificationNumber: 1800
  },
  19: {
    Id: 19,
    Name: 'major_classification.miscellaneous_services',
    Localization: 'major_classification.miscellaneous_services',
    ClassificationNumber: 1900
  }
};
